$(".bundleSetProduct").on("click", function(){
  if($(this).hasClass("active")) {
    $(this).removeClass("active");
    $(".descriptionSetOriginal, .ketWineFactSetOriginal, .experReviewsWrapperSetOriginal").addClass("active");
    $(".descriptionSet:not(.descriptionSetOriginal), .ketWineFactSet:not(.ketWineFactSetOriginal), .experReviewsWrapperSet:not(.experReviewsWrapperSetOriginal), .criticReviewsSetSection").removeClass("active");

    //Change Image
    $(".product-gallery__thumbnail")?.first().click();
  } else {
    let productId = $(this).attr("data-productid");
    $(".bundleSetProduct").not(this).removeClass("active");
    $(this).addClass("active");
    let selectedDes = $(".descriptionSet[data-productid='"+productId+"']");
    let selectedKeyWine = $(".ketWineFactSet[data-productid='"+productId+"']");
    let selectedExpertReview = $(".experReviewsWrapperSet[data-productid='"+productId+"']");
    let selectedExpertReviewSection = $(".criticReviewsSetSection[data-productid='"+productId+"']");
    $(".descriptionSet").not(selectedDes).removeClass("active");
    $(".ketWineFactSet").not(selectedKeyWine).removeClass("active");
    $(".experReviewsWrapperSet").not(selectedExpertReview).removeClass("active");
    $(".criticReviewsSetSection").not(selectedExpertReviewSection).removeClass("active");
    selectedDes.addClass("active");
    selectedKeyWine.addClass("active");
    selectedExpertReview.addClass("active");
    selectedExpertReviewSection.addClass("active");

    //Change Image
    let check1 = true;
    $(".product-gallery__thumbnail img").each(function(){
      if(check1) {
        let thisAlt = $(this).attr("alt");
        if(thisAlt && thisAlt.indexOf(productId) > -1) {
          $(this).closest(".product-gallery__thumbnail").click();
          check1 = false;
        }
      }
    });
  }
});